import { faTrash, faPlusCircle } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useContext, useEffect, useState } from 'react'
import { Row, Col, Button, Form } from 'react-bootstrap'
import { LanguageContext } from '../Language/LanguageContext'
import { Loading, UserProfileImage } from '../Library'
import { AlertModalContext } from '../Library/AlertModalContext'
import { listuserSuperadmin, listDepartmentByUser, listBuilding } from '../Network/Administration'
import { listSelectByBuilding } from '../Network/Company'
import { listDepartment, addUserToDepartment, removeFromDepartment } from '../Network/Department'
import "./UserAlias.css"

function UserAlias() {
    const alertModal = useContext(AlertModalContext)
    const langCx = useContext(LanguageContext)
    const lang = langCx.lang.administration
    const [userList, setUserList] = useState([])
    const [departmentItems, setDepartmentItem] = useState([])
    const [userSelected, setUserSelected] = useState(null)
    const [isLoading, setIsLoading] = useState(false)

    const fetchUserDepartment = (userId) => {
        listDepartmentByUser(userId,
            (data) => {
                setDepartmentItem(data)
            },
            (error) => {

            })
    }

    const onRemoveUserDepartment = (userId, departmentId) => {
        alertModal.setTitle(lang.delete_department_user)
        alertModal.setDescription(lang.delete_department_user_desc)
        alertModal.setAlertType("EXTREME")
        alertModal.setButton([
            {
                title: langCx.lang.confirm.ok,
                variant: "danger",
                onClick: ()=>{ 
                    removeFromDepartment(userId, departmentId,
                        () => { 
                            fetchUserDepartment(userSelected)
                            alertModal.setIsShow(false) 
                        },
                        () => {  })
                }
            },
            {
                title: langCx.lang.confirm.cancel,
                variant: "secondary",
                onClick: ()=>{ 
                    alertModal.setIsShow(false) 
                }
            }
        ])
        alertModal.setIsShow(true)
    }

    const onUserChange = (userId) => {
        setUserSelected(userId)
        fetchUserDepartment(userId)
    }

    useEffect(()=>{
        const fetchData = () => {
            setIsLoading(true)
            listuserSuperadmin(
                (data)=>{
                    setUserList(data)
                    setUserSelected(data[0].id)
                    fetchUserDepartment(data[0].id)
                    setIsLoading(false)
                },
                (error) => {
                    setIsLoading(false)
                }
            )
        }
        fetchData()
    },[])

    function UserItem({ firstname, lastname, email, profilePath, isSelected, onClick }){
        return(
            <div 
            className={ isSelected ? 'user-item user-item-active': 'user-item'} 
            onClick={onClick}>
                <UserProfileImage
                selected={isSelected}
                profileImagePath={profilePath}
                />
                <div style={{ marginLeft: 13 }}>
                    <div className='title'>{`${firstname} ${lastname}`}</div>
                    <div className='detail'>{email}</div>
                </div>
            </div>
        )
    }
    
    function DepartmentItem({ departmentName, companyName, buildingName, onRemoveClick }){
        return(
            <div className='department-item'>
                <div style={{ flex: 1 }}>
                    <div className='title'>{lang.department}: {departmentName}</div>
                    <div className='detail'>{lang.company}: {companyName}</div>
                    <div className='detail'>{lang.building}: {buildingName}</div>
                </div>
                <div>
                    <Button
                    variant='danger'
                    size="sm"
                    onClick={onRemoveClick}
                    >
                        <FontAwesomeIcon icon={faTrash}/>
                    </Button>
                </div>
            </div>
        )
    }    

    const AddDepartmentButton = () => {
        const [isAdd, setIsAdd] = useState(false)
        const [buildingList, setBuildingList] = useState([])
        const [companyList, setCompanyList] = useState([])
        const [departmentList, setDepartmentList] = useState([])

        const [selectBuilding,setSelectBuilding] = useState("")
        const [selectCompany, setSelectCompany] = useState("")
        const [selectDepartment, setSelectDepartment] = useState("")

        const addDepartment = () => {
            addUserToDepartment(userSelected, selectDepartment,
                () => {
                    setIsAdd(false)
                    fetchUserDepartment(userSelected)
                },
                (error) => {})
        }

        useEffect(()=>{
            const fetchBuilding = () => {
                listBuilding(
                    (data) => { setBuildingList(data) },
                    (error) => {  }
                )
            }
            const fetchCompany = () => {
                listSelectByBuilding(selectBuilding,
                    (data) => { setCompanyList(data) },
                    (error) => {  })
            }
            const fetchDepartment = () => {
                listDepartment(selectCompany,
                    (data) => { setDepartmentList(data) },
                    (error) => {  })
            }

            fetchBuilding()
            if(selectBuilding !== ""){
                fetchCompany()
            }
            if(selectCompany !== ""){
                fetchDepartment()
            }
        },[selectBuilding, selectCompany, selectDepartment])

        return(
            <div className='add-department-btn'>
                { isAdd ?
                <div className='add-form'>
                    <Form
                    onSubmit={(e) => {
                        e.preventDefault()
                        addDepartment()
                    }}
                    >
                        <Form.Group>
                            <Form.Label>{lang.building}</Form.Label>
                            <Form.Control as="select"
                            onChange={(e)=>setSelectBuilding(e.target.value)}>
                                <option value="">{lang.select_building}</option>
                                { buildingList.map((item, key) =>
                                <option key={key} value={item.id}>{item.buildingName}</option>
                                )}
                            </Form.Control>
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>{lang.company}</Form.Label>
                            <Form.Control
                            as="select"
                            disabled={!selectBuilding ? true:false}
                            onChange={(e)=>setSelectCompany(e.target.value)}
                            >
                                <option value="">{lang.select_company}</option>
                                { companyList.map((item, key) =>
                                <option key={key} value={item.id}>{item.name}</option>   
                                )}
                            </Form.Control>
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>{lang.department}</Form.Label>
                            <Form.Control 
                            as="select"
                            disabled={!selectCompany ? true: false}
                            onChange={(e)=>setSelectDepartment(e.target.value)}>
                                <option value="">{lang.select_department}</option>
                                { departmentList.map((item, key) =>
                                <option key={key} value={item.id}>{item.name}</option>  
                                )}
                            </Form.Control>
                        </Form.Group>
                        <div style={{ display: 'flex' }}>
                            <Button 
                            type="submit"
                            style={{ flex: 1 }}>
                                {lang.add_department}
                            </Button>
                            <Button 
                            variant='secondary'
                            style={{ flex: 1, marginLeft: 13 }}
                            onClick={()=>setIsAdd(false)}>
                                {lang.cancel}
                            </Button>
                        </div>
                       
                    </Form>
                </div>
                :
                <div className='add-button' onClick={()=>setIsAdd(true)}>
                    <FontAwesomeIcon icon={faPlusCircle}/>
                    <span style={{ marginLeft: 8 }}>{lang.add_department}</span>
                </div>
                }
            </div>
        )
    }

    return (
        <div id="user-alias">
            { isLoading ? <Loading/>: null }
            <div style={{ marginBottom: 13 }}>{lang.user_alias_desc}</div>
            <Row>
                <Col lg={6}>
                    <div className='user-alias-container'>
                        { userList.map((item, key) =>
                        <UserItem
                        key={key}
                        firstname={item.firstName}
                        lastname={item.lastName}
                        email={item.email}
                        profilePath={item.profileImagePath}
                        isSelected={userSelected === item.id ? true : false }
                        onClick={()=>onUserChange(item.id)}
                        />
                        )}
                    </div>

                </Col>
                <Col lg={6}>
                    <div className='user-alias-container'>
                        { departmentItems?.map((item, key) => 
                        <DepartmentItem
                        key={key}
                        departmentName={item.department.name}
                        companyName={item.company.name}
                        buildingName={item.building.buildingName}
                        onRemoveClick={()=>onRemoveUserDepartment(userSelected, item.department.id)}
                        />
                        )}
                        <AddDepartmentButton/>
                    </div>
                </Col>
            </Row>
        </div>
    )
}
export default UserAlias